export default "__VITE_ASSET__6824p9MB__"